// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N3BZYK {
  max-width: 480px;
  width: 100%;
}

.G2k7UQ {
  padding: var(--spacing-3, 24px);
  padding-top: var(--spacing-1, 8px);
}

.cZ2AdU {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
  animation: pMhxsa 0.3s ease-out 0.1s both;
}

.JwWc_C {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  color: var(--text-neutral-dark, #1f1f1f);
}

.KjvTdA {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
}

.SoAzzD {
  display: flex;
  justify-content: center;
  width: 100%;
}

.uLYDUW {
  display: flex;
  width: 100%;
}

@media (max-width: 768px) {
  .N3BZYK {
    max-width: 90vw;
    margin: var(--spacing-2, 16px);
  }

  .G2k7UQ {
    padding: var(--spacing-2, 16px);
    padding-top: var(--spacing-1, 8px);
  }

  .cZ2AdU {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2, 16px);
    animation: pMhxsa 0.3s ease-out 0.1s both;
  }
}

@keyframes pMhxsa {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/PasswordInputModal/PasswordInputModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAgD;AAClD;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,yCAAgD;EAClD;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".modal {\n  max-width: 480px;\n  width: 100%;\n}\n\n.customBody {\n  padding: var(--spacing-3, 24px);\n  padding-top: var(--spacing-1, 8px);\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n  animation: contentFadeIn 0.3s ease-out 0.1s both;\n}\n\n.description {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.label {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.confirmButton {\n  display: flex;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .modal {\n    max-width: 90vw;\n    margin: var(--spacing-2, 16px);\n  }\n\n  .customBody {\n    padding: var(--spacing-2, 16px);\n    padding-top: var(--spacing-1, 8px);\n  }\n\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-2, 16px);\n    animation: contentFadeIn 0.3s ease-out 0.1s both;\n  }\n}\n\n@keyframes contentFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `N3BZYK`,
	"customBody": `G2k7UQ`,
	"container": `cZ2AdU`,
	"contentFadeIn": `pMhxsa`,
	"description": `JwWc_C`,
	"label": `KjvTdA`,
	"actions": `SoAzzD`,
	"confirmButton": `uLYDUW`
};
module.exports = ___CSS_LOADER_EXPORT___;
